import * as tvx from "../../lib/tvx-plugin-module.min";
import { res_studios, serviceMap } from "../../static-res";
import { getDisplayedItems } from "../content-utils";

let currentIndex = 0;

export function updateStudiosIcons(type: number): void {
  const displaingStudios = getDisplayedItems(
    Array.from(serviceMap.entries()),
    currentIndex,
    type
  );
  currentIndex = displaingStudios.newIndex;
  for (let i = 0; i < displaingStudios.items.length; i++) {
    tvx.InteractionPlugin.executeAction(
      `update:content:home-studios-id${i + 1}`,
      {
        image: displaingStudios.items[i][1],
      }
    );
  }
  tvx.InteractionPlugin.stopLoading();
}

export function studioRow(): tvx.MSXContentPage {
  const page: tvx.MSXContentPage = {
    headline: res_studios(),
    items: [
      {
        type: "default",
        layout: "0,0,1,2",
        icon: "arrow-back-ios",
        iconSize: "small",
        action: "interaction:commit:message:content:home:studios:back",
      },
      studioItem(1),
      studioItem(2),
      studioItem(3),
      studioItem(4),
      studioItem(5),
      {
        type: "default",
        layout: "11,0,1,2",
        icon: "arrow-forward-ios",
        iconSize: "small",
        action: "interaction:commit:message:content:home:studios:forward",
      },
    ],
  };

  return page;
}
function studioItem(positionIndex: number): tvx.MSXContentItem {
  let entries = Array.from(serviceMap.entries());
  const serviceIndex = positionIndex + currentIndex - 1;

  let serviceImage =
    serviceIndex >= 0 && serviceIndex < entries.length
      ? entries[serviceIndex][1]
      : undefined;
  
  let serviceName = 
    serviceIndex >= 0 && serviceIndex < entries.length
      ? entries[serviceIndex][0]
      : undefined;
      
  const xPosition = positionIndex * 2 - 1;
  const item: tvx.MSXContentItem = {
    id: `home-studios-id${positionIndex}`,
    type: "default",
    layout: `${xPosition},0,2,2`,
    image: serviceImage,
    action: serviceName ? `interaction:commit:message:content:home:studios:click:${serviceName}` : undefined,
  };
  return item;
}
